// @flow

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { historyRoomsFragment } from 'common/fragments'

const roomGQL = gql`
  query {
    viewer {
      ${historyRoomsFragment}
    }
  }
`

export default function(component: any) {
  return graphql(roomGQL, {
    skip: ({ config }) => config.SSR,
  })(component)
}



// WEBPACK FOOTER //
// ./src/containers/organisms/room/RoomCardSlider/BrowseRoomHistories/graphql.js